import { render, staticRenderFns } from "./OpportunityDetailsCard.vue?vue&type=template&id=3217aabf&scoped=true&"
import script from "./OpportunityDetailsCard.vue?vue&type=script&lang=js&"
export * from "./OpportunityDetailsCard.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityDetailsCard.vue?vue&type=style&index=0&id=3217aabf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3217aabf",
  null
  
)

export default component.exports